import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';

export type MarketplaceEntityWithStates = { marketplaceEntity: { states?: StateAbbreviation[] } };

export const filterEntitiesByState = <T extends MarketplaceEntityWithStates>(
  items: T[],
  state?: StateAbbreviation,
): T[] => {
  if (!items) return [];
  if (!state) return items;
  return items.filter(item => {
    const validStates = item.marketplaceEntity.states;
    return !Array.isArray(validStates) || validStates.length === 0 || validStates.includes(state);
  });
};
